/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorTwitter from 'base/components/labrador/Twitter';

export const DynamicLabradorTwitter: typeof LabradorTwitter = (props) => {
    return <ErrorBoundary><LabradorTwitter {...props} /></ErrorBoundary>;
}
export type DynamicLabradorTwitterProps = PropsFromComponent<typeof LabradorTwitter>;
